import { render, staticRenderFns } from "./RVLDetermination.vue?vue&type=template&id=3a4ddb4c&scoped=true"
import script from "./RVLDetermination.vue?vue&type=script&lang=js"
export * from "./RVLDetermination.vue?vue&type=script&lang=js"
import style0 from "./RVLDetermination.vue?vue&type=style&index=0&id=3a4ddb4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4ddb4c",
  null
  
)

export default component.exports